import React from "react";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

import Success from "components/Typography/Success.jsx";
import CardHeader from "components/CardHeader.jsx";
import CardBody from "components/CardBody.jsx";
import CardFooter from "components/CardFooter";

import Schedule from "@material-ui/icons/Schedule";

import { mlAuto } from "assets/jss/material-kit-pro-react.jsx";

const getDescription = (body, characterCount) => {
  body = removeTags(body);
  body = body.substring(0, characterCount);
  body = body.substring(0, body.lastIndexOf(" "));
  return body + " ...";
};

const removeTags = input => (input ? input.replace(/<[^>]+>/gm, "") : "");

const useStyles = makeStyles(theme => ({
  mlAuto,
  card: {
    height: "100%",
    boxShadow: theme.shadows[3],
    borderRadius: "6px",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  cardImage: {
    "& img": {
      borderRadius: "6px 6px 0 0",
    },
  },
  cardCategory: {
    marginTop: "10px",
    "& svg": {
      position: "relative",
      top: "8px",
    },
    color: "#1d9cd9",
  },
  content: {
    margin: "1rem 0",
  },
  readMore: {
    color: "#CA61DC",
    "& :hover": {
      color: "#89229B",
    },
  },
  avatar: {
    width: "30px",
    height: "30px",
    overflow: "hidden",
    borderRadius: "50%",
    marginRight: "5px",
  },
  author: {
    display: "inline-flex",
    "& a": {
      color: "#3C4858",
    },
  },
  stats: {
    color: "#999999",
    display: "flex",
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      position: "relative",
      top: "3px",
      marginRight: "3px",
      marginLeft: "3px",
      fontSize: "18px",
      lineHeight: "18px",
    },
    "& svg": {
      position: "relative",
      top: "3px",
      marginRight: "3px",
      marginLeft: "3px",
      width: "18px",
      height: "18px",
    },
  },
}));

const BlogCard = ({ blog, characterCount = 160, imageHeight = 240, footer = true }) => {
  const classes = useStyles();
  return (
    <motion.div className={classes.card} whileHover={{ y: -10 }}>
      <div>
        <CardHeader className={classes.cardImage} image plain noShadow>
          <Link to={`/blogs/${blog.urlId}-${blog.id}`}>
            <img src={blog.blogThumbnail} alt={blog.title} style={{ height: imageHeight }} />
          </Link>
        </CardHeader>
        {/* <Divider /> */}
        <CardBody>
          <Success>
            <h6 className={classes.cardCategory}>{blog.category}</h6>
          </Success>
          <div>
            <Typography component={Link} to={`/blogs/${blog.urlId}-${blog.id}`} variant="h5">
              {blog.title}
            </Typography>
          </div>

          <div className={classes.content}>
            <Typography variant="body1">{getDescription(blog.body, characterCount)}</Typography>

            <Typography
              className={classes.readMore}
              variant="body1"
              component={Link}
              to={`/blogs/${blog.urlId}-${blog.id}`}>
              {" "}
              Read More
            </Typography>
          </div>
        </CardBody>
      </div>
      {footer && (
        <CardFooter>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ display: "flex" }}>
              <img src={blog.authorThumbnail} alt="..." className={classes.avatar} />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                lineHeight: "17px",
              }}>
              <div
                style={{
                  fontSize: 13,
                  fontWeight: 400,
                  color: "#656565",
                }}>
                {blog.author}
              </div>
              {/* <div
          style={{
            fontSize: 11,
            fontWeight: 300,
            color: "#656565",
          }}
        >
          {getDuration(blog.createdAt)}
        </div> */}
            </div>
          </div>
          <div className={`${classes.stats} ${classes.mlAuto}`}>
            <Schedule />
            {blog.duration} min read
          </div>
        </CardFooter>
      )}
    </motion.div>
  );
};

export default BlogCard;
